const BankCode = {
  // Production
  UOVBSGSGXXX: 'UOVBSGSGXXX',
  DBSSSGSGXXX: 'DBSSSGSGXXX',
  CITISGSLXXX: 'CITISGSLXXX',
  OCBCSGSGXXX: 'OCBCSGSGXXX',
  HSBCSGS2XXX: 'HSBCSGS2XXX',
  SCBLSG22XXX: 'SCBLSG22XXX',
  BKCHSGSGXXX: 'BKCHSGSGXXX',
  ICBKSGSGXXX: 'ICBKSGSGXXX',
  MBBESGS2XXX: 'MBBESGS2XXX',
  SSPISGSGXXXL: 'SSPISGSGXXXL',
  // UAT
  BKCHSGS0XXX: 'BKCHSGS0XXX',
  ZYYJSGS0XXX: 'ZYYJSGS0XXX',
  DBSSSGS0XXX: 'DBSSSGS0XXX',
  ZYFISGS0XXX: 'ZYFISGS0XXX',
  ICBKSGS0XXX: 'ICBKSGS0XXX',
  SSPISGS0XXX: 'SSPISGS0XXX',
  ZYGPSGS0XXX: 'ZYGPSGS0XXX',
  OCBCSGS0XXX: 'OCBCSGS0XXX',
  SCBLSG20XXX: 'SCBLSG20XXX',
  UOVBSGS0XXX: 'UOVBSGS0XXX',
};

const BANK_ENUM = {
  // Production
  [BankCode.UOVBSGSGXXX]: {
    code: BankCode.UOVBSGSGXXX,
    name: 'UOB',
    iconPath: '/assets/icons/my-giving/bank-logo-uob.png',
  },
  [BankCode.DBSSSGSGXXX]: {
    code: BankCode.DBSSSGSGXXX,
    name: 'DBS',
    iconPath: '/assets/icons/my-giving/bank-logo-dbs.png',
  },
  [BankCode.CITISGSLXXX]: {
    code: BankCode.CITISGSLXXX,
    name: 'Citibank',
    iconPath: '/assets/icons/my-giving/bank-logo-citibank.png',
  },
  [BankCode.OCBCSGSGXXX]: {
    code: BankCode.OCBCSGSGXXX,
    name: 'OCBC',
    iconPath: '/assets/icons/my-giving/bank-logo-ocbc.png',
  },
  [BankCode.HSBCSGS2XXX]: {
    code: BankCode.HSBCSGS2XXX,
    name: 'HSBC',
    iconPath: '/assets/icons/my-giving/bank-logo-hsbc.png',
  },
  [BankCode.SCBLSG22XXX]: {
    code: BankCode.SCBLSG22XXX,
    name: 'Standard Chartered Bank',
    iconPath: '/assets/icons/my-giving/bank-logo-scb.png',
  },
  [BankCode.BKCHSGSGXXX]: {
    code: BankCode.BKCHSGSGXXX,
    name: 'Bank of China',
    iconPath: '/assets/icons/my-giving/bank-logo-bank-of-china.png',
  },
  [BankCode.ICBKSGSGXXX]: {
    code: BankCode.ICBKSGSGXXX,
    name: 'ICBC',
    iconPath: '/assets/icons/my-giving/bank-logo-icbc.png',
  },
  [BankCode.MBBESGS2XXX]: {
    code: BankCode.MBBESGS2XXX,
    name: 'Maybank',
    iconPath: '/assets/icons/my-giving/bank-logo-maybank.png',
  },
  [BankCode.SSPISGSGXXXL]: {
    code: BankCode.SSPISGSGXXXL,
    name: 'MariBank',
    iconPath: '/assets/icons/my-giving/bank-logo-maribank.png',
  },
  // UAT
  [BankCode.BKCHSGS0XXX]: {
    code: BankCode.BKCHSGS0XXX,
    name: 'UAT Bank of China',
    iconPath: '/assets/icons/my-giving/bank-logo-bank-of-china.png',
  },
  [BankCode.ZYYJSGS0XXX]: {
    code: BankCode.ZYYJSGS0XXX,
    name: 'UAT Citibank',
    iconPath: '/assets/icons/my-giving/bank-logo-citibank.png',
  },
  [BankCode.DBSSSGS0XXX]: {
    code: BankCode.DBSSSGS0XXX,
    name: 'UAT DBS',
    iconPath: '/assets/icons/my-giving/bank-logo-dbs.png',
  },
  [BankCode.ZYFISGS0XXX]: {
    code: BankCode.ZYFISGS0XXX,
    name: 'UAT HSBC',
    iconPath: '/assets/icons/my-giving/bank-logo-hsbc.png',
  },
  [BankCode.ICBKSGS0XXX]: {
    code: BankCode.ICBKSGS0XXX,
    name: 'UAT ICBC',
    iconPath: '/assets/icons/my-giving/bank-logo-icbc.png',
  },
  [BankCode.SSPISGS0XXX]: {
    code: BankCode.SSPISGS0XXX,
    name: 'UAT MariBank',
    iconPath: '/assets/icons/my-giving/bank-logo-maribank.png',
  },
  [BankCode.ZYGPSGS0XXX]: {
    code: BankCode.ZYGPSGS0XXX,
    name: 'UAT Maybank',
    iconPath: '/assets/icons/my-giving/bank-logo-maybank.png',
  },
  [BankCode.OCBCSGS0XXX]: {
    code: BankCode.OCBCSGS0XXX,
    name: 'UAT OCBC',
    iconPath: '/assets/icons/my-giving/bank-logo-ocbc.png',
  },
  [BankCode.SCBLSG20XXX]: {
    code: BankCode.SCBLSG20XXX,
    name: 'UAT Standard Chartered Bank',
    iconPath: '/assets/icons/my-giving/bank-logo-scb.png',
  },
  [BankCode.UOVBSGS0XXX]: {
    code: BankCode.UOVBSGS0XXX,
    name: 'UAT UOB',
    iconPath: '/assets/icons/my-giving/bank-logo-uob.png',
  },
};

const BANK_LIST = Object.values(BANK_ENUM);
const BANK_BY_NAME = Object.fromEntries(BANK_LIST.map(b => [b.name, b]));

module.exports = {
  BankCode,
  BANK_ENUM,
  BANK_LIST,
  BANK_BY_NAME,
};
